import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationModel } from '../../shared/models/notification.model';
import { filter, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from 'app/app.reducers';
import { selectUserNotifications } from '../../store/selectors/notifications.selectors';
import { NotificationsActions } from '../../store/actions/notifications.actions';
import { Property } from 'app/internal/property/shared/models/property';
import { getSelectedProperty } from 'app/internal/property/property-store/property.selectors';
import { SubSink } from 'subsink';

@Component({  
  standalone: false,
  templateUrl: './user-notifications.component.html',
  styleUrl: './user-notifications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNotificationsComponent implements OnInit, OnDestroy {

  userNotifications$: Observable<NotificationModel[]>;
  property$: Observable<Property>;

  private subs = new SubSink();

  constructor(
    private store: Store<AppState>
  ) {
    this.property$ = this.store.pipe(select(getSelectedProperty));
    this.userNotifications$ = this.store.pipe(select(selectUserNotifications));
  }

  ngOnInit(): void {

    this.subs.sink = this.property$
      .pipe(filter((p) => p !== null))
      .subscribe((property) => {
        this.store.dispatch(NotificationsActions.loadUserNotifications({ propertyId: property.propertyId }));
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
